import ErrorPage from "../views/page/error/ErrorPage";
import React, { useState, useEffect } from "react";
import { Route, Routes, useLocation } from 'react-router-dom';

import "../assets/scss/styles.scss";

import RouterSetting from "./router.setting";
import RouterMember from "./router.member";
import RouterBoard from "./router.board";
import RouterManage from "./router.manage";

import Login from "../views/page/member/Login";
import { jwtDecode } from 'jwt-decode';
import SessionStorage from '../utils/SessionStorage.utils';
import { redirectToLogin } from '../utils/AdminAuth.utils';
import RequireAuth from './RequireAuth'; // RequireAuth

// 사용이 중단된 화면은 인증 여부와 관계없이 주소를 유지한 채 404로 표시한다.
// 활성 목록에서 연결되는 상세·작성 화면과 관리자 정보 화면은 기존 라우트를 유지한다.
const inactiveRoutes = [
  "/Product/*",
  "/Reserve/*",
  "/Payment/*",
  "/Refund/*",
  "/about/*",
  "/dashboard/*",
  "/Member/MemberLeave/*",
  "/Board/Faq/Category/*",
  "/Board/MedicalTeam/*",
  "/Board/Picture/*",
  "/Board/ProductReview/*",
  "/Board/Review/*",
  "/Manage/Chatting/*",
  "/Manage/Consult/*",
  "/Setting/Manager/SubAdmin/*",
  "/Setting/Design/*",
  "/Setting/Account/*",
  "/Setting/Push/*",
  "/Setting/Coupon/*",
  "/Setting/SearchKeyword/*",
  "/Setting/Policy/*",
];

function Routers() {
  const pathName = useLocation().pathname;
  const isLoginPage = /^\/login\/?$/i.test(pathName);
  const [loginStatus, setLoginStatus] = useState(localStorage.getItem('isLoggedIn') === 'true');
  console.log('loginStatus', loginStatus)
  useEffect(() => {
    /** access token 이 아직 유효한지 만료 시각으로 판단한다. 형식이 깨졌으면 만료로 본다. */
    const isAccessTokenAlive = (accessToken) => {
      try {
        const { exp } = jwtDecode(accessToken);

        // 만료 전에 갱신을 요청하면 서버가 202 로 거부한다. 갱신은 실제로 만료된 뒤에만 한다.
        // 확인 직후 만료되는 경계는 이후 API 호출의 401 인터셉터가 처리한다.
        return typeof exp === "number" && exp * 1000 > Date.now();
      } catch (error) {
        return false;
      }
    };

    const verifyToken = async () => {
      const adminSession = SessionStorage.getItemJsonParse("adminSession");
      // const RefreshToken = SessionStorage.getItemJsonParse("adminSession");

      if (!adminSession || !adminSession.accessToken) return;

      // 아직 유효한 토큰이면 서버에 묻지 않는다. 갱신은 만료됐을 때만 필요하다.
      if (isAccessTokenAlive(adminSession.accessToken)) {
        setLoginStatus(true);
        return;
      }

      try {
        let base = process.env.REACT_APP_API_URL; // api 주소
        const response = await fetch(base + '/admin/token/refresh', {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${adminSession.accessToken}`
          },
          body: JSON.stringify({ refresh: adminSession.refreshToken })
        });

        if (response.ok) {
          // 재발급된 토큰을 저장하지 않으면 localStorage 에 만료된 토큰이 그대로 남아
          // 이후 모든 API 가 401 로 떨어진다.
          // access token 이 아직 유효하면 서버가 202 로 응답하므로 data 가 없다.
          const result = await response.json().catch(() => null);

          if (result?.messageCode === 200 && result?.data?.accessToken) {
            SessionStorage.setItem('adminSession', 'accessToken', result.data.accessToken);
            SessionStorage.setItem('adminSession', 'refreshToken', result.data.refreshToken || adminSession.refreshToken);
          }

          setLoginStatus(true);
        } else if (response.status === 401 || response.status === 400) {
          // refresh token 만료·다른 환경 토큰처럼 서버가 갱신을 거부하면 다시 로그인해야만 풀린다.
          // 화면에 들어가도 API 가 모두 401 로 떨어지므로 로그인 화면으로 보낸다
          redirectToLogin();
        } else {
          setLoginStatus(false);
        }
      } catch (error) {
        // 응답 자체를 받지 못한 경우(네트워크 단절 등)는 인증 실패가 아니므로 로그인 상태를 유지한다.
        // 토큰이 정말 만료됐다면 이후 API 호출에서 401 인터셉터가 갱신을 처리한다.
        console.warn('토큰 확인 요청 실패 - 네트워크 오류로 보고 로그인 상태를 유지한다:', error?.message);
        setLoginStatus(true);
      }
    };

    verifyToken();
  }, []);
  return (
    <div className={`${isLoginPage ? `` : `adm_com_container`
      }`}>
      <Routes>
        {inactiveRoutes.map((path) => (
          <Route key={path} path={path} element={<ErrorPage />} />
        ))}
        <Route exact path="/Login" element={<Login setLoginStatus={setLoginStatus} />} />
        <Route path="/404" element={<ErrorPage />} />

        {/* <Route exact path="/" element={<Dashboard />} /> */}
        {/* <Route exact path="/" element={<RouterMember />} /> */}
        <Route path="/" element={
          <RequireAuth chkLevel={1} chkDepth={3}>
            <RouterMember />
          </RequireAuth>
        } />
        <Route path="/Setting/*" element={
          <RequireAuth chkLevel={1} chkDepth={3}>
            <RouterSetting />
          </RequireAuth>
        } />
        <Route path="/Member/*" element={
          <RequireAuth chkLevel={1} chkDepth={3}>
            <RouterMember />
          </RequireAuth>
        } />
        <Route path="/Board/*" element={
          <RequireAuth chkLevel={1} chkDepth={3}>
            <RouterBoard />
          </RequireAuth>
        } />
        <Route path="/Manage/*" element={
          <RequireAuth chkLevel={1} chkDepth={3}>
            <RouterManage />
          </RequireAuth>
        } />
        {/* <Route exact path="/Setting/*" element={<RouterSetting />} />
        <Route exact path="/Member/*" element={<RouterMember />} /> */}
        {/* <Route exact path="/Board/*" element={<RouterBoard />} /> */}
        
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </div>
  );
}

export default Routers;
